"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class CustomerApi extends runtime.BaseAPI {
    /**
     * This method adds a customer to the Jira Service Management instance by passing a JSON file including an email address and display name. The display name does not need to be unique. The record\'s identifiers, `name` and `key`, are automatically generated from the request details.  **[Permissions](#permissions) required**: Jira Administrator Global permission
     * Create customer
     */
    createCustomerRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['customerCreateDTO'] == null) {
                throw new runtime.RequiredError('customerCreateDTO', 'Required parameter "customerCreateDTO" was null or undefined when calling createCustomer().');
            }
            const queryParameters = {};
            if (requestParameters['strictConflictStatusCode'] != null) {
                queryParameters['strictConflictStatusCode'] = requestParameters['strictConflictStatusCode'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:servicedesk-customer"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/customer`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CustomerCreateDTOToJSON)(requestParameters['customerCreateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.UserDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method adds a customer to the Jira Service Management instance by passing a JSON file including an email address and display name. The display name does not need to be unique. The record\'s identifiers, `name` and `key`, are automatically generated from the request details.  **[Permissions](#permissions) required**: Jira Administrator Global permission
     * Create customer
     */
    createCustomer(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCustomerRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.CustomerApi = CustomerApi;
//# sourceMappingURL=CustomerApi.js.map